import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { Settings } from '@atlaskit/atlassian-navigation';
import { ButtonItem, MenuGroup, Section } from '@atlaskit/menu';
import { AnalyticsTrackSubject, trackButtonClick } from '@atlassian/temp-analytics';
import { UFOUiAction, ufoHandleButtonClick } from '@atlassian/temp-observability';
import Popup from '@atlaskit/popup';
import { routePaths } from '@css-xp/ppc-constants';
import { getRouteUrl } from '@css-xp/ppc-utils';

interface props {
  txaId?: string;
}

export const AppSettingsMenu = ({ txaId }: props) => {
  const [showSettingsMenu, setShowSettingsMenu] = useState(false);

  const SettingsContent = () => {
    const history = useHistory();
    const location = useLocation();

    const navigateTo = (url: string) => {
      const appropriateUrl = getRouteUrl(url, { txaId: txaId ?? '' });
      if (location.pathname !== routePaths.partnerOnboarding) {
        history.push(appropriateUrl);
      }
      setShowSettingsMenu(false);
    };

    return (
      <MenuGroup>
        <Section title="Settings">
          <ButtonItem
            testId="partner-onboarding-option"
            onClick={() => {
              ufoHandleButtonClick(UFOUiAction.NAVIGATION_BAR_PARTNER_ONBOARDING);
              trackButtonClick(AnalyticsTrackSubject.NAVIGATION_BAR_PARTNER_ONBOARDING);
              navigateTo(routePaths.partnerOnboarding);
            }}
          >
            API Onboarding
          </ButtonItem>
          <ButtonItem
            testId="partner-notifications-settings"
            onClick={() => {
              ufoHandleButtonClick(UFOUiAction.MANAGE_NOTIFICATION_PREFERENCE);
              trackButtonClick(AnalyticsTrackSubject.MANAGE_NOTIFICATION_PREFERENCE);
              navigateTo(routePaths.manageNotifications);
            }}
          >
            Settings
          </ButtonItem>
        </Section>
      </MenuGroup>
    );
  };

  useEffect(() => {
    if (showSettingsMenu) {
      ufoHandleButtonClick(UFOUiAction.NAVIGATION_BAR_SETTINGS);
      trackButtonClick(AnalyticsTrackSubject.NAVIGATION_BAR_SETTINGS);
    }
  }, [showSettingsMenu]);

  return (
    <Popup
      content={SettingsContent}
      testId="setting-button-popover"
      isOpen={showSettingsMenu}
      placement="bottom-end"
      onClose={() => setShowSettingsMenu(false)}
      trigger={(triggerProps) => (
        <Settings
          {...triggerProps}
          testId="setting-button-trigger"
          onClick={() => setShowSettingsMenu((prev) => !prev)}
          tooltip="settings"
        />
      )}
    />
  );
};
